const colors = {
  pink: "#ff248e",
  wine: "#9a2d42",
  honey: "#fff0e9",
  white: "#ffffff",
};

export default colors;
